module.exports = __webpack_public_path__ + "static/media/bannerSilverBackground.2a17b030.png";